export default __webpack_public_path__ + "static/Ecoswim_Carton+ControlUnit+Chlorinator-9698ad13f721e3ac55d6b96d2f87757c.png";